module.exports = __webpack_public_path__ + "static/media/Subsuperficial.c34f0e3d.svg";